/**
 * AnimatedFlowCyan — Custom edge with cyan base line + animated white dashes
 * Used for pumps → departure connections
 */
import { type EdgeProps, getBezierPath } from '@xyflow/react';

export function AnimatedFlowCyan(props: EdgeProps) {
    const [edgePath] = getBezierPath(props);

    return (
        <g>
            {/* Ligne cyan solide fixe */}
            <path
                d={edgePath}
                fill="none"
                stroke="#26C6DA"
                strokeWidth={3}
            />
            {/* Ligne blanche pointillée animée par-dessus */}
            <path
                d={edgePath}
                fill="none"
                stroke="white"
                strokeWidth={2}
                strokeDasharray="8 12"
                style={{
                    animation: 'dash-flow 1.5s linear infinite',
                }}
            />
        </g>
    );
}
